<template>
  <div class="flex gap-2">
    <Copy v-if="!clicked" class="w-4 h-4 hover:cursor-pointer" @click="copyToClipboard" />
    <Check v-else class="w-4 h-4" />
    {{ props.text }}
  </div>
</template>

<script setup lang="ts">
import { createException } from '@/utils/monitoring.utils';
import { delay } from '@/utils/time.utils';
import { Check, Copy } from 'lucide-vue-next';
import { ref } from 'vue';

const clicked = ref(false);

const props = defineProps<{
  text: string;
}>();

const copyToClipboard = async () => {
  try {
    clicked.value = true;
    await navigator.clipboard.writeText(props.text);
  } catch (e) {
    createException(e);
  } finally {
    await delay(250);
    clicked.value = false;
  }
};
</script>
